<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/zcyg/zcyg-title.png" class="zcqd-title" alt="">
        </div>
        <div class="zcyg-info">
          <div class="category-list">
            <div class="category-item top" style="top: -85px; left: -12px;" :class="{active: activeIndex == 0 }" @click="getzcygList(tabList[0])">
              <div class="item-name">新时代科技强国 · 战略阶段</div>
              <div class="item-time">2020~至今</div>
            </div>
            <div class="category-item bottom" style="top: 87px; left: 267px;" :class="{active: activeIndex == 1 }" @click="getzcygList(tabList[1])">
              <div class="item-name">自主创新 · 战略阶段</div>
              <div class="item-time">2006~2019</div>
            </div>
            <div class="category-item top " style="top: -85px; right: 553px;" :class="{active: activeIndex == 2 }" @click="getzcygList(tabList[2])">
              <div class="item-name">科教兴国 · 战略阶段</div>
              <div class="item-time">1992~2005</div>
            </div>
            <div class="category-item bottom" style="top: 65px; right: 274px;" :class="{active: activeIndex == 3 }" @click="getzcygList(tabList[3])">
              <div class="item-name">商品经济时代 · 改革阶段</div>
              <div class="item-time">1977~1991</div>
            </div>
            <div class="category-item top" style="top: -46px; right: 0;" :class="{active: activeIndex == 4 }" @click="getzcygList(tabList[4])">
              <div class="item-name">计划经济时代 · 探索阶段</div>
              <div class="item-time">1949~1976</div>
            </div>
          </div>
          <div class="zcyg-list">

            <div class="zcyg-item" v-for="(item,ind) in zcygList" :key="ind" @click="toDetail(item)">
              <div class="item-scale">
                <div class="zcyg-name">{{item.title}}</div>
                <div class="zcyg-time">{{item.abstract}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="more" @click="toMoreList()">查看更多</div>
      </div>
    </div>

  </div>
</template>

<script>
import services from "../../../assets/js/services.js"
import { mapActions } from "vuex";
export default {
  props: ["scaling"],
  mounted() {
    this.getzcygList(this.tabList[0])
  },

  data() {
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
      tabList: [
        {
          title: '新时代科技强国 战略阶段',

          ind: 0
        },
        {
          title: '自主创新 战略阶段',
          ind: 1
        },
        {
          title: '科教兴国 战略阶段',
          ind: 2
        },
        {
          title: '商品经济时代 改革阶段',
          ind: 3
        },
        {
          title: '计划经济时代 探索阶段',
          ind: 4
        },
      ],
      zcygList: [],
      activeIndex: 0
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    async getzcygList(item) {
      this.activeIndex = item.ind
      let res = await services.getAreaSzztkLists({
        page: 1,
        length: 4,
        count: 0,
        school_code: this.school_code,
        special_id: this.specialId,
        kind: "1",
        column_name: item.title,
        order_by: "asc"
      })
      if (res.code == "0000" && res.data.items) {
        this.zcygList = res.data.items
      }

    },
    toDetail(item) {
      if (item) {
        this.goAppsDetailsBeforeLogin().then(() => {
          if (item.is_open_url == 2) {
            window.open(`${item.source_url}`, "_blank");
            console.log(item.source_url);

          } else {

            let routeUrl = this.$router.resolve({
              path: `/${this.school_code}/kjqg/detail`,
              query: {
                id: item.id,
                column_id: item.column_id,
                columnPath: "zcqdkc",
              },
            });
            window.open(routeUrl.href, "_blank");
          }
        });
      }
    },
    toMoreList() {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/zcqdkc?ind=1`,
        });
        window.open(routeUrl.href, "_blank");
      });
    },
  }
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;

  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          max-width: 812px;
          margin-top: 40px;
        }
      }
      .zcyg-info {
        .category-list {
          margin: 107px auto 0;

          width: 1402px;
          height: 92px;
          background-image: url("../../../assets/image/kjqg/index/zcyg/zcyg-list.png");
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;

          .category-item {
            width: 303px;
            height: 76px;
            background-size: cover;
            background-position: center;
            display: flex;
            justify-content: space-between;
            position: absolute;
            cursor: pointer;
            &.active {
              .item-name {
                color: #ffffff;
              }
              .item-time {
                color: #ffffff;
              }
              &::before {
                background-image: url("../../../assets/image/kjqg/index/zcyg/item-icon-active.png");
              }
              &.top {
                background-image: url("../../../assets/image/kjqg/index/zcyg/category-item-top-hover.png");
              }
              &.bottom {
                background-image: url("../../../assets/image/kjqg/index/zcyg/category-item-bottom-hover.png");
              }
            }
            &:hover {
              .item-name {
                color: #ffffff;
              }
              .item-time {
                color: #ffffff;
              }
              &::before {
                background-image: url("../../../assets/image/kjqg/index/zcyg/item-icon-active.png");
              }
              &.top {
                background-image: url("../../../assets/image/kjqg/index/zcyg/category-item-top-hover.png");
              }
              &.bottom {
                background-image: url("../../../assets/image/kjqg/index/zcyg/category-item-bottom-hover.png");
              }
            }
            &::before {
              content: "";
              display: block;
              position: absolute;
              width: 19px;
              height: 22px;
              background-image: url("../../../assets/image/kjqg/index/zcyg/item-icon.png");
              background-size: cover;
              left: 50%;
              transform: translateX(-50%);
            }
            &.top {
              background-image: url("../../../assets/image/kjqg/index/zcyg/category-item-top.png");
              flex-direction: column;
              padding-top: 20px;
              &::before {
                bottom: -38px;
              }
            }
            &.bottom {
              flex-direction: column-reverse;
              background-image: url("../../../assets/image/kjqg/index/zcyg/category-item-bottom.png");
              padding-bottom: 20px;
              &::before {
                top: -38px;
              }
            }
            .item-name {
              font-weight: bold;
              font-size: 16px;
              color: #2b427c;
              text-align: center;
            }
            .item-time {
              font-weight: 400;
              font-size: 14px;
              color: #075ff6;
              text-align: center;
              line-height: 28px;
            }
          }
        }
        .zcyg-list {
          margin: 109px auto 0;
          width: 1398px;
          height: 461px;
          background-image: url("../../../assets/image//kjqg/index/zcyg/zcyg-bg.png");
          background-size: cover;
          position: relative;
          padding: 60px 130px 0;
          display: flex;
          &::before {
            content: "";
            display: inline-block;
            width: 1314px;
            height: 372px;
            background: #94caf7;
            border-radius: 20px 20px 0px 0px;
            opacity: 0.76;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          .zcyg-item {
            position: relative;
            width: 240px;
            height: 340px;
            z-index: 1;
            margin-right: 60px;
            &:hover {
              .item-scale {
                background: linear-gradient(0deg, #bcb098 0%, #f1e2c8 50%);
                box-shadow: 0px 0px 10px 0px rgba(131, 148, 197, 0.69);
                border: 1px solid #ce3227;
                transform: translate(-50%, -50%) scale(1.1);
              }
            }
            &:last-child {
              margin-right: 0;
            }
            .item-scale {
              width: 240px;
              height: 340px;
              position: absolute;
              transition: all 0.3s;
              cursor: pointer;
              left: 50%;
              top: 50%;
              background: linear-gradient(0deg, #bcb098 0%, #f1e2c8 50%);
              border: 1px solid #e3ebf3;
              transform: translate(-50%, -50%);
              display: flex;
              flex-direction: column;
              padding: 55px 20px 50px;
              justify-content: space-between;
              cursor: pointer;
              .zcyg-name {
                font-weight: bold;
                font-size: 18px;
                color: #ad190e;
                line-height: 32px;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4; /* 控制显示的行数 */
              }
              .zcyg-time {
                width: 192px;
                height: 34px;
                background: #db961b;
                border-radius: 17px;
                font-weight: 400;
                font-size: 14px;
                color: #ffffff;
                text-align: center;
                line-height: 34px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: 0 5px;
              }
            }
          }
        }
      }

      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;

        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        margin: 25px auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>